<template>
  <RouterView />
</template>

<script lang="ts" setup>
import { onErrorCaptured } from "vue";

onErrorCaptured((err, instance, info) => {
  // eslint-disable-next-line
  console.error(err, info);
  throw err;
});
</script>
